// "Contact us" drawer in the header (snippets/header-contact.liquid).
// Opens a native modal <dialog> that slides in from the right and slides back out before closing.
if (!customElements.get('contact-drawer')) {
  customElements.define(
    'contact-drawer',
    class ContactDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('.header__contact-button');
        if (!this.dialog || !this.opener) return;

        this.opener.addEventListener('click', () => this.open());

        // A click on the dialog element itself lands on the dimmed backdrop (its content box is filled).
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('[data-close]')) this.close();
        });

        // Escape: animate out instead of closing instantly.
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });

        // Runs however the dialog ends up closed (including a forced Escape close).
        this.dialog.addEventListener('close', () => {
          this.dialog.classList.remove('is-closing');
          document.body.classList.remove('overflow-hidden');
        });
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();
        document.body.classList.add('overflow-hidden');
      }

      close() {
        if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;

        const finish = () => {
          this.dialog.close();
          this.opener.focus();
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          finish();
          return;
        }

        const onAnimationEnd = (event) => {
          if (event.animationName !== 'header-drawer-out') return;
          this.dialog.removeEventListener('animationend', onAnimationEnd);
          finish();
        };
        this.dialog.addEventListener('animationend', onAnimationEnd);
        this.dialog.classList.add('is-closing');
      }
    }
  );
}
